//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import throttle from '@/utils/throttle';
export default {
  name: 'widget__list',
  props: {
    request: {
      type: Function,
      required: true
    },
    items: Array,
    paging: Object
  },
  created: function created() {
    this.onReachBottom = throttle(this.onReachBottom);
    window.addEventListener('scroll', this.onReachBottom, false);
    var _this$paging = this.paging,
      pageNo = _this$paging.pageNo,
      pageSize = _this$paging.pageSize;
    this.request(pageNo, pageSize);
  },
  methods: {
    onReachBottom: function onReachBottom() {
      var isReachBottom = window.scrollY + window.innerHeight >= document.body.offsetHeight;
      if (!this.isLoading && this.paging.hasMore && isReachBottom) {
        // 不在加载中，有更多，且触底，则加载下一页
        var _this$paging2 = this.paging,
          pageNo = _this$paging2.pageNo,
          pageSize = _this$paging2.pageSize;
        this.request(++pageNo, pageSize);
      }
    }
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.onReachBottom, false);
  }
};